import { Feature } from '~/components/Feature';
import { FEATURE_FLAGS } from '~/constants';
import { AddNewPlatformsModal } from '~/screens/ManagePlatforms/AddNewPlatformsModal';
import {
  EditPlatformsModal_DEPRECATED,
  useEditPlatformsStore,
} from '~/screens/ManagePlatforms/EditPlatformsModal_DEPRECATED';
import { RemovePlatformModal } from '~/screens/ManagePlatforms/RemovePlatformModal';

export const ManagePlatforms: React.FC = () => {
  const { connectedPlatforms } = useEditPlatformsStore();
  return (
    <>
      <Feature name={FEATURE_FLAGS.foamOffPlatformAddSocials}>
        <EditPlatformsModal_DEPRECATED />
        <AddNewPlatformsModal />
      </Feature>
      {connectedPlatforms.length > 1 ? (
        <Feature name={FEATURE_FLAGS.foamOffPlatformRemoveSocials}>
          <RemovePlatformModal />
        </Feature>
      ) : null}
    </>
  );
};
